// TitleDesInputComponent.jsx
import CKEditorInlineBubbleComponent from "@/styledUIComponent/CKEditor/CKEditorInlineBubbleComponent.jsx";
import { useState } from "react";
import { Button, Card, Input } from "@material-tailwind/react";
import { createFaq } from "@/api/faqApi.jsx";

const TitleDesInputComponent = ({ handleCancel, refreshFaqs }) => {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");

    const handleCreate = () => {
        if (!title.trim() || !content.trim()) {
            alert("제목과 설명은 비워둘 수 없습니다.");
            return;
        }

        createFaq({ title: title, des: content })
            .then((res) => {
                if (res.status === 200) {
                    alert(res.data.message || "FAQ가 성공적으로 생성되었습니다.");
                    setTitle("");
                    setContent("");
                    handleCancel();
                    refreshFaqs(); // 생성 후 데이터 다시 가져오기
                } else {
                    alert(res.data.message || "FAQ 생성에 실패했습니다.");
                }
            })
            .catch((err) => {
                console.error("FAQ 생성 오류:", err);
                alert("FAQ 생성 중 오류가 발생했습니다.");
            });
    };

    return (
        <Card className="mb-4">
            <div className="p-4">
                <div className="flex flex-row justify-between my-4 gap-4">
                    <Input
                        className="w-full"
                        label="제목"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <div className="flex gap-4">
                        <Button color="green" onClick={handleCreate}>
                            Confirm
                        </Button>
                        <Button color="red" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </div>
                </div>
                <CKEditorInlineBubbleComponent content={content} setContent={setContent} />
            </div>
        </Card>
    );
};

export default TitleDesInputComponent;